import styled from 'styled-components';
import Column from '@sdk/components/ui/spacing/Column';
import Button from '@sdk/components/ui/buttons/Button';
import Text16 from '@sdk/components/ui/typography/Text16';
import Text14 from '@sdk/components/ui/typography/Text14';

export const BillingWarningContainer = styled(Column)`
  background-color: ${({ theme }) => theme.colors.bodyBg};
  border-radius: 8px;
  padding: 40px;
  width: 470px;
`;

export const BillingWarningCTA = styled(Button)`
  width: 140px;
`;

export const BillingWarningTitle = styled(Text16)`
  font-weight: bold;
  margin-top: 10px;
`;

export const BillingWarningDescription = styled(Text14)`
  color: ${(props) => props.theme.colors.gray};
  margin: 10px 0 20px 0;
  text-align: center;
`;
